export default "__VITE_ASSET__36ojV0XX__"